import constructLocalEntity from 'src/utils/vuexModuleConstructor/constructLocalEntity';
import { isInteger, hideWhenCreatingAndEditing } from 'src/types/columnFlags';
const controlledActions = {
    create: [649],
    fetch: [650],
    update: [651],
    delete: [652],
    downloadList: [650],
    uploadList: [-1]
};
const columns = (state, getters, rootState, rootGetters) => {
    return [
        { name: 'row_menu', style: 'width:20px', hideWhenCreatingAndEditing, type: 'row_menu', menuItemShortcuts: ['del'] },
        { name: 'id', style: 'width:10px', isInteger, hideWhenCreatingAndEditing },
        { name: 'name', label: 'Name', inlineEdit: true, required: true },
        { name: 'description', label: 'Description', inlineEdit: true },
        { name: 'description_for_ai', label: 'Description for AI', inlineEdit: true },
        { name: 'rdf_text_document_content', label: 'RDF Text Document Content', isCode: true, codeLanguage: 'rdf' },
    ];
};
const localEntity = constructLocalEntity({
    columns,
    remoteEntityName: 'apps.apps',
    entityLabel: 'Application',
    entityLabelPlural: 'Applications',
    apiVersion: 1,
    controlledActions,
    pageTitle: 'Apps',
    genericTableDefaultProps: () => ({
        startingSortingModelProp: [{ application_order: 1, field: 'id', direction: 'desc' }]
    })
});
export default localEntity;
